<template lang="pug">
span
  v-menu(v-model="showMenu" rounded="lg" allow-overflow attach :close-on-content-click="false" offset-y max-height="360" min-width="320" max-width="320" nudge-bottom="8" content-class="custom-menu")
    template(v-slot:activator="{ on, attrs }")
      v-btn.px-2.button-text-normal.button-filter.text-none(v-if="selectedValue" outlined rounded height="28" v-bind="attrs" v-on="on")
        v-icon.mr-1(@click.stop="clear" size=13) $yzi-x-circle
        .text-xs.font-semibold {{ $t('birthday') }}
        .px-1.neutral400--text | 
        .text-xs.primary--text.font-medium {{ selectedValue }}
        v-icon.ml-1(size=16) $yzi-chevron-down
      v-btn.px-2.button-text-normal.border-dashed.button-filter(v-else outlined rounded height="28" v-bind="attrs" v-on="on")
        v-icon.mr-1(size=13) $yzi-plus-circle
        .text-xs.text-none.font-semibold {{ $t('birthday') }}

    .pa-4.white(style="border-radius: inherit;")
      .font-semibold.mb-3.text-sm {{ $t('filter_by') }} {{ $t('birthday').toLowerCase() }}
      y-select.mb-2(v-model="option" :items="options" item-value="id" item-text="name" small attach @change="clearData()")
      .d-flex.align-start
        v-icon.mx-2(size=16 color="primary") $yzi-corner-down-right
        template(v-if="option === 'birthday_is'")
          y-select(v-model="timeperiod" :items="timeperiods" item-value="id" item-text="name" small attach)
        v-row(v-if="option === 'birthday_on'" dense)
          v-col(cols="5")
            y-select(v-model="daydate" :items="getDaylist(monthdate)" small attach placeholder="day")
          v-col(cols="7")
            y-select(v-model="monthdate" :items="getMonthlist(daydate)" item-value="value" item-text="text" small attach placeholder="month")
        div(v-if="option === 'birthday_between'")
          v-row(dense)
            v-col(cols="5")
              y-select(v-model="daydate" :items="getDaylist(monthdate)" small attach placeholder="day")
            v-col(cols="7")
              y-select(v-model="monthdate" :items="getMonthlist(daydate)" item-value="value" item-text="text" small attach placeholder="month")
          div.text-center.text-xs.neutral500--text.my-2 to
          v-row(dense)
            v-col(cols="5")
              y-select(v-model="enddaydate" :items="getDaylist(endmonthdate)" small attach placeholder="day")
            v-col(cols="7")
              y-select(v-model="endmonthdate" :items="getMonthlist(enddaydate)" item-value="value" item-text="text" small attach placeholder="month")
        template(v-if="option === 'dob_month'")
          y-select(v-model="monthdate" :items="getMonthlist(daydate)" item-value="value" item-text="text" small attach placeholder="month")
        v-row(v-if="option === 'dob_month_between'" dense)
          v-col
            y-select(v-model="monthdate" :items="getMonthlist(daydate)" item-value="value" item-text="text" small attach placeholder="month")
          v-col(cols="1")
            div.text-center.text-xs.neutral500--text.mt-3 to
          v-col
            y-select(v-model="endmonthdate" :items="getMonthlist(enddaydate)" item-value="value" item-text="text" small attach placeholder="month")
        template(v-if="option === 'birthday_span_neg'")
          v-text-field.round-xl(v-model="durationValue" hide-details outlined dense placeholder="Value" type="number")
          y-select.ml-2(v-model="duration" :items="durations" item-value="id" item-text="name" small attach)
        template(v-if="option === 'birthday_span_pos'")
          v-text-field.round-xl(v-model="durationValue" hide-details outlined dense placeholder="Value" type="number")
          y-select.ml-2(v-model="duration" :items="durations" item-value="id" item-text="name" small attach)

    .bottom-0.sticky.z-1.white(style="border-radius: inherit;")
      .d-flex.align-center.px-4.py-3.border-t
        .text-sm.font-semibold.underline.normal-case.neutral700--text.cursor-pointer(v-if="!disabledButton" @click="clear") {{ $t('clear') }}
        v-spacer
        v-btn.button-sm(@click="apply" color="primary" depressed :disabled="disabledButton") {{ $t('apply') }}

</template>

<script>

export default {
  props: {
    filter: {
      type: Object,
      default: (() => {})
    },
    title: {
      type: String,
      default: 'Date'
    },
    param: {
      type: String,
      default: 'date'
    },
    checkInitialValue: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      showMenu: false,
      option: 'birthday_is',
      duration: 'days',
      timeperiod: 'today',
      daydate: null,
      enddaydate: null,
      endmonthdate: null,
      monthdate: null,
      durationValue: null,
      selectedValue: null,
      options: [
        { id: 'birthday_is', name: 'Is' },
        { id: 'birthday_on', name: 'Is on' },
        { id: 'birthday_between', name: 'Is between day and month of' },
        { id: 'dob_month', name: 'Is in the month of' },
        { id: 'dob_month_between', name: 'Is between the months of' },
        { id: 'birthday_span_neg', name: 'Is in the last' },
        { id: 'birthday_span_pos', name: 'Is in the next' },
      ],
      timeperiods: [
        { id: 'today', name: 'Today' },
        { id: 'tomorrow', name: 'Tomorrow' },
        { id: 'this_week', name: 'This week' },
        { id: 'this_month', name: 'This month' },
        { id: 'next_week', name: 'Next week' },
        { id: 'next_month', name: 'Next month' },
      ],
      durations: [
        { id: 'days', name: 'Days' },
        { id: 'weeks', name: 'Weeks' },
        { id: 'months', name: 'Months' }
      ],
      months: [
        { text: 'January', value: 1 },
        { text: 'February', value: 2 },
        { text: 'March', value: 3 },
        { text: 'April', value: 4 },
        { text: 'May', value: 5 },
        { text: 'June', value: 6 },
        { text: 'July', value: 7 },
        { text: 'August', value: 8 },
        { text: 'September', value: 9 },
        { text: 'October', value: 10 },
        { text: 'November', value: 11 },
        { text: 'December', value: 12 }
      ]
    }
  },
  computed: {
    disabledButton () {
      if (this.option === 'birthday_is' && this.timeperiod) {
        return false
      }
      if (this.option === 'birthday_on' && this.daydate && this.monthdate) {
        return false
      }
      if (this.option === 'birthday_between' && this.daydate && this.monthdate && this.enddaydate && this.endmonthdate) {
        return false
      }
      if (this.option === 'dob_month' && this.monthdate) {
        return false
      }
      if (this.option === 'dob_month_between' && this.monthdate && this.endmonthdate ) {
        return false
      }
      if (this.option === 'birthday_span_neg' && this.durationValue && this.duration) {
        return false
      }
      if (this.option === 'birthday_span_pos' && this.durationValue && this.duration) {
        return false
      }
      return true
    }
  },
  watch: {
    filter: {
      handler () {
        if (!this.filter.key) { this.clearData() }
      } 
    },
  },
  mounted () {
    this.setData()
  },
  methods: {
    setData () {
      if (this.checkInitialValue) {
        if (this.filter.key) {
          this.option = this.filter.key
          if (this.option === 'birthday_is') {
            this.timeperiod = this.filter.value.value
            this.selectedValue = `Is ${this.timeperiod.replace(/_/g, ' ')}`
          }
          if (this.option === 'birthday_on') {
            let value = this.filter.value.value.split('-')
            this.daydate = Number(value[0])
            this.monthdate = Number(value[1])
            this.selectedValue = `Is on ${this.daydate} ${this.getMonthName(this.monthdate)}`
          }
          if (this.option === 'birthday_between') {
            let valueStart = this.filter.value[0].value.split('-')
            let valueEnd = this.filter.value[1].value.split('-')
            this.daydate = Number(valueStart[0])
            this.monthdate = Number(valueStart[1])
            this.enddaydate = Number(valueEnd[0])
            this.endmonthdate = Number(valueEnd[1])
            this.selectedValue = `Is between ${this.daydate} ${this.getMonthName(this.monthdate)} and ${this.enddaydate} ${this.getMonthName(this.endmonthdate)}`
          }
          if (this.option === 'dob_month') {
            this.monthdate = Number(this.filter.value.value)
            this.selectedValue = `Is in the month of ${this.getMonthName(this.monthdate)}`
          }
          if (this.option === 'dob_month_between') {
            this.monthdate = Number(this.filter.value[0].value)
            this.endmonthdate = Number(this.filter.value[1].value)
            this.selectedValue = `Is in the months between ${this.getMonthName(this.monthdate)} and ${this.getMonthName(this.endmonthdate)}`
          }
          if (this.option === 'birthday_span_neg') {
            let value = this.filter.value.value.split(',')
            this.durationValue = value[0].replace(/[^0-9.]/g, '')
            this.duration = value[1]
            this.selectedValue = `Is in the last ${this.durationValue} ${this.duration}`
          }
          if (this.option === 'birthday_span_pos') {
            let value = this.filter.value.value.split(',')
            this.durationValue = value[0]
            this.duration = value[1]
            this.selectedValue = `Is in the next ${this.durationValue} ${this.duration}`
          }
        }
      }
    },
    clear () {
      this.clearData()
      this.$emit('update:filter', {})
    },
    clearData () {
      this.selectedValue = null
      this.durationValue = null
      this.duration = 'days'
      this.timeperiod = 'today'
      this.daydate = null
      this.enddaydate = null
      this.endmonthdate = null
      this.monthdate = null
    },
    getDaylist (month) {
      let days = []
      for (let i = 1; i <= 31; i++) {
        days.push(i)
      }
      if (month) {
        if ([4,6,9,11].includes(month)) {
          days = days.filter(f => f <= 30)
        } else if (month === 2) {
          days = days.filter(f => f <= 29)
        }
      }
      return days
    },
    getMonthlist (day) {
      let months = JSON.parse(JSON.stringify(this.months))
      if (day) {
        if (day === 31) {
          months = months.filter(f => [1,3,5,7,8,10,12].includes(f.value))
        } else if (day === 30) {
          months = months.filter(f => [4,6,9,11].includes(f.value))
        }
      }
      return months
    },
    getMonthName (monthdate) {
      let monthname = this.months.find(f => f.value == monthdate)
      if (monthname) {
        return monthname.text
      }
      return monthdate
    },
    apply () {
      this.showMenu = false
      let filter = {}
      if (this.option === 'birthday_is') {
        filter = { 
          key: this.option, 
          value: { 
            key: 'birthday', 
            value: this.timeperiod 
          } 
        }
        this.selectedValue = `Is ${this.timeperiod.replace(/_/g, ' ')}`
      } else if (this.option === 'birthday_on') {
        filter = { 
          key: this.option, 
          value: { 
            key: 'birthday', 
            value: `${this.daydate}-${this.monthdate}` 
          } 
        }
        this.selectedValue = `Is on ${this.daydate} ${this.getMonthName(this.monthdate)}`
      } else if (this.option === 'birthday_between') {
        filter = { 
          key: this.option, 
          value: [
            { 
              key: 'birthday__gte', 
              value: `${this.daydate}-${this.monthdate}` 
            }, 
            { 
              key: 'birthday__lte', 
              value: `${this.enddaydate}-${this.endmonthdate}` 
            }
          ] 
        }
        this.selectedValue = `Is between ${this.daydate} ${this.getMonthName(this.monthdate)} and ${this.enddaydate} ${this.getMonthName(this.endmonthdate)}`
      } else if (this.option === 'dob_month') {
        filter = { 
          key: this.option, 
          value: { 
            key: 'dob__month', 
            value: this.monthdate 
          } 
        }
        this.selectedValue = `Is in the month of ${this.getMonthName(this.monthdate)}`
      } else if (this.option === 'dob_month_between') {
        filter = { 
          key: this.option, 
          value: [
            { 
              key: 'dob__month__gte', 
              value: this.monthdate 
            }, 
            { 
              key: 'dob__month__lte', 
              value: this.endmonthdate 
            }
          ] 
        }
        this.selectedValue = `Is in the months between ${this.getMonthName(this.monthdate)} and ${this.getMonthName(this.endmonthdate)}`
      } else if (this.option === 'birthday_span_neg') {
        filter = { 
          key: this.option, 
          value: { 
            key: 'birthday_span', 
            value: [-this.durationValue, this.duration].join()
          } 
        }
        this.selectedValue = `Is in the last ${this.durationValue} ${this.duration}`
      } else if (this.option === 'birthday_span_pos') {
        filter = { 
          key: this.option, 
          value: { 
            key: 'birthday_span', 
            value: [this.durationValue, this.duration].join()
          } 
        }
        this.selectedValue = `Is in the next ${this.durationValue} ${this.duration}`
      }
      this.$emit('update:filter', filter)
    }
  }
}
</script>

<style lang="scss" scoped>
.button-filter {
  min-width: 0 !important;
  color: #848484;
}
::v-deep {
  .custom-menu {
    overflow: unset;
    contain: unset;
  }
}
</style>